import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as retrievePlanzoneLogs from "./retrievePlanzoneLogs";

const initialState: State = {
  retrievePlanzoneLogs: retrievePlanzoneLogs.initialState,
};

const reduceState = combineStateReducer(initialState, {
  retrievePlanzoneLogs: retrievePlanzoneLogs.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...retrievePlanzoneLogs.createSelector(
      () => getState().retrievePlanzoneLogs,
    ),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
